import type { Component } from 'vue'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { createApp } from 'vue'

import '~/app/styles/style.css'

import { router } from '~/app'
import * as UiComponent from '~/shared/ui/components'
import { Root } from '~/widgets/layout'

const app = createApp(Root)

Object.entries(UiComponent).forEach(([name, component]) => {
    app.component(name, component as Component)
})

app.use(router)
app.use(VueQueryPlugin)
app.mount('#app')
